import { SparkleIcon } from "@/components/icons/Sparkle";
import { Skill } from "@/types/types";
import { getSkillCategoryLabel } from "./skills-picker-lib";

export const SkillPickerRow: React.FC<{
  skill: Skill;
}> = ({ skill }) => {
  return (
    <span className="flex w-full items-center justify-between gap-2">
      <span className="flex min-w-0 items-center gap-2">
        <SparkleIcon size={14} className="shrink-0" />
        <span className="truncate" title={skill.name}>
          {skill.name}
        </span>
      </span>
      <span className="text-muted-foreground shrink-0 text-xs">
        {getSkillCategoryLabel(skill.category)}
      </span>
    </span>
  );
};
